<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		DoubleDeviceButton,
		DoubleDeviceButtonV2,
		type DeviceButtonV2PropsTypes,
	} from '@Shelly/shelly-design-system';
	//Component
	import VirtualButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	let className = '';
	export { className as class };

	export let device: Device, statuses: VCInterfaceStatus[];
	export let useV2Components = false;
	export let deviceButtonV2Props: Partial<DeviceButtonV2PropsTypes> = {
		size: 's',
	};

	let isLoading = false;

	$: statusUp = statuses.find((i) => /^(up|open)$/.test(i.role));
	$: statusDown = statuses.find((i) => /^(down|close)$/.test(i.role));
</script>

{#if useV2Components && statusUp?.id && statusDown?.id}
	<DoubleDeviceButtonV2
		id="doubledevicebutton-0beoe5z"
		aria-label={$format('button_label_close_open', {
			default: 'Close / Open',
		})}
		{isLoading}
		class={className}
		isActive={false}
		{...deviceButtonV2Props}
	>
		<VirtualButton
			slot="buttonLeft"
			{device}
			hasDarkIcon
			componentID={statusUp.id}
			value={statusUp.event}
			icon={statusUp.icon}
			{deviceButtonV2Props}
			{useV2Components}
			bind:isLoading
		/>
		<VirtualButton
			slot="buttonRight"
			{device}
			hasDarkIcon
			componentID={statusDown.id}
			value={statusDown.event}
			icon={statusDown.icon}
			{deviceButtonV2Props}
			{useV2Components}
			bind:isLoading
		/>
	</DoubleDeviceButtonV2>
{:else if statusUp?.id && statusDown?.id && !useV2Components}
	<DoubleDeviceButton
		id="doubledevicebutton-0beoe5z"
		aria-label={$format('button_label_close_open', {
			default: 'Close / Open',
		})}
		{isLoading}
		class={className}
		isActive={false}
	>
		<VirtualButton
			slot="buttonLeft"
			{device}
			hasDarkIcon
			componentID={statusUp.id}
			value={statusUp.event}
			icon={statusUp.icon}
			bind:isLoading
		/>
		<VirtualButton
			slot="buttonRight"
			{device}
			hasDarkIcon
			componentID={statusDown.id}
			value={statusDown.event}
			icon={statusDown.icon}
			bind:isLoading
		/>
	</DoubleDeviceButton>
{/if}
